<template>
  <master-main
    :exportProperties="{
      pdf: {
        filename: `${$t('labor.type_of_contract')}.pdf`,
        route: `${getModuleRoute}/pdf`,
      },
      xls: {
        filename: `${$t('labor.type_of_contract')}.xlsx`,
        route: `${getModuleRoute}/excel`,
      },
    }"
    :dataBadges="[
      {
        columnLabel: $t('common_words.associated_companies2'),
        data: 'businesses',
        property: 'name',
        minWidth: 180,
      },
    ]"
    :route="getModuleRoute"
    :tableProperties="tableProperties"
    @closeModal="handleCloseModal"
    @openModal="handleOpenModal"
    @refresh="refresh"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    ref="masterMain"
  >
    <template slot="dialogForm">
      <edit-or-create-contract
        :syncDialog="modals"
        @addEdit="addEdit"
        @closeModal="handleCloseModal"
        @showHideLoading="showHideLoading"
        @showNotification="notifyVue"
        ref="editCreate"
      />
    </template>
  </master-main>
</template>
<script>
import EditCreate from './EditCreate.vue';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinWithDialog from 'src/mixins/master/mixin-with-dialog';
import ContractTable from './type-contracts-table';

export default {
  components: { MasterMain, [EditCreate.name]: EditCreate },
  data() {
    return {
      tableProperties: {},
    };
  },
  mixins: [
    MixinAlert,
    MixinLoading,
    MixinMain,
    MixinPermissions,
    MixinWithDialog,
  ],
  computed: {
    getModuleRoute() {
      return 'works/typecontracts';
    },
    buildTableProperties() {
      return {
        tableColumns: [...ContractTable().tableColumns],
        model: 'typecontract',
        effectTags: 'dark',
        widthColumnStatus: 160,
        defaultSort: { prop: 'code', order: 'ascending' },
      };
    },
  },
};
</script>
